import * as React from 'react';
import { ISingleNotification } from '../alert-type';
import OENotification from '../../../oe-notification/oe-notification';

interface IProps {
  notificationsList: ISingleNotification[];
}

const NotificationsContainer: React.FC<IProps> = ({ notificationsList }) => {
  return notificationsList?.length
    ? (
      <div className='oe-notification-list'>
          {notificationsList.map((notificationState, index) => {
              return <OENotification
                  key={index}
                  popupProps={notificationState.popupProps}
              />;
          })}
      </div>
    )
    : null;
};

export { NotificationsContainer };
